import { destroyCookie } from 'nookies'

export function deleteCookie(key: string) {
  destroyCookie(null, key, {
    path: '/',
    //domain: window.location.hostname.substring(window.location.hostname.indexOf('.')),
  })
  return true
}
